import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-service-request-management',
  imports: [RouterModule, FeatureHero],
  templateUrl: './service-request-management.html',
  styleUrl: './service-request-management.scss',
})
export class ServiceRequestManagement {

}
